import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import type { MRT_DisplayColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import {
  ROUTER_PATHS,
  calcLineaNameContrato,
  emptyCellOneLevel,
} from '@/shared';
import { CustomTableLink, SingleButton } from '@/shared/components/ui';
import { Contrato } from '@/shared/interfaces';
// import { ContractStateChip, DataContractStateChip } from '../components';
import dayjs from 'dayjs';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';

export const useClientesCoorporativosColumns = () => {

  const clientesFibraOpticaReturnUrl =
    ROUTER_PATHS.contabilidad.clientesCoorporativosNav;

  ///* basic -----------------------
  const base01 = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'Identificación',
        size: 60,
        Cell: ({ row }) =>
          row.original?.cliente_data?.identificacion ? (
            <>
              <CustomTableLink
                url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
                text={row.original?.cliente_data?.identificacion}
              />
            </>
          ) : (
            'N/A'
          ),
      },
      {
        accessorKey: 'razon_social',
        header: 'Nombre',
        size: 333,
        Cell: ({ row }) => {
          const calculatedName = calcLineaNameContrato(row?.original! || {});

          return row.original?.cliente_data?.razon_social ? (
            <CustomTableLink
              url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
              text={calculatedName}
            />
          ) : (
            'N/A'
          );
        },
      },


      // estado de información ------------------
      // {
      //   accessorKey: 'estado_actualizacion',
      //   header: 'Estado Contrato',
      //   enableColumnFilter: false,
      //   size: 250,
      //   Cell: ({ row }) => {
      //     return <DataContractStateChip statusData={row.original?.estado_actualizacion!} />;
      //   },
      // },
      // estado servicio ------------------
      // {
      //   accessorKey: 'estado_servicio',
      //   header: 'Estado Servicio',
      //   enableColumnFilter: false,
      //   size: 222,
      //   Cell: ({ row }) => {
      //     return <ContractStateChip contract={row.original} />;
      //   },
      // },


      // contrato ------------------
      {
        accessorKey: 'numero_referencia',
        header: 'Núm. Contrato',
        size: 90,
        Cell: ({ row }) => emptyCellOneLevel(row, 'numero_referencia'),
      },
      {
        accessorKey: 'url_contrato',
        header: 'CONTRATO',
        size: 90,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const url = row.original?.url_contrato;
          if (!url) return 'N/A';

          return (
            <SingleButton
              newCustomButton
              iconButton
              label="Ver contrato"
              color="error"
              startIcon={<PictureAsPdfIcon />}
              onClick={() => {
                window.open(url, '_blank');
              }}
            />
          );
        },
      },

      
    ],
    []
  );


  ///* tables -----------------------
  const clientesCorporativosColumns = useMemo<MRT_DisplayColumnDef<IFactibilidadCorporativo>[]>(
    () => [
      {
        accessorKey: 'prospecto_corporativo_data.identificacion',
        header: 'Identificación',
        size: 60,
        // Cell: ({ row }) =>
        //   row.original?.cliente_data?.identificacion ? (
        //     <>
        //       <CustomTableLink
        //         url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
        //         text={row.original?.cliente_data?.identificacion}
        //       />
        //     </>
        //   ) : (
        //     'N/A'
        //   ),
      },
      {
        accessorKey: 'prospecto_corporativo_data.razon_social',
        header: 'Razón Social',
        size: 333,
        // Cell: ({ row }) => {
        //   const calculatedName = calcLineaNameContrato(row?.original! || {});

        //   return row.original?.cliente_data?.razon_social ? (
        //     <CustomTableLink
        //       url={`${clientesFibraOpticaReturnUrl}/ver/${row.original?.id_contrato}`}
        //       text={calculatedName}
        //     />
        //   ) : (
        //     'N/A'
        //   );
        // },
      },

      {
        accessorKey: 'celular',
        header: 'celular',
        size: 90,
        Cell: ({ row }) => row.original?.preventa_corporativa_data?.celular || row.original?.preventa_corporativa_data?.celular_1  || "",
      },
      // contrato ------------------
      {
        accessorKey: 'numero_referencia',
        header: 'Núm. Contrato',
        size: 90,
        Cell: ({ row }) => emptyCellOneLevel(row, 'numero_referencia'),
      },
      {
        accessorKey: 'user_create',
        header: 'Usuario',
        size: 90,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          return row.original?.user_create;
          
        },
      },
    ],
    []
  );

  const clientesCorporativosColumnsFilterMotivos = useMemo<MRT_DisplayColumnDef<Contrato>[]>(
    () => [
      ...base01,
      {
        accessorKey: 'responsable_razon_social',
        header: 'Responsable',
        // enableColumnFilter: false,
        size: 400,
        Cell: ({ row }) => row.original?.supervisor_data?.razon_social || row.original?.user_create_data?.razon_social || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato.ultimos_motivos_correccion',
        header: 'Último Motivo de Corrección',
        enableColumnFilter: false,
        size: 300,
        Cell: ({ row }) => row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length-1]?.motivos?.toString() || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato',
        header: 'Última Observación Técnico',
        enableColumnFilter: false,
        size: 400,
        Cell: ({ row }) => row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length-1]?.observaciones_tecnico?.toString() || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato',
        header: 'Última Observación Ventas',
        enableColumnFilter: false,
        size: 400,
        Cell: ({ row }) => row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length-1]?.observaciones_ventas?.toString() || "N/A",
      },
      {
        accessorKey: 'observaciones_contrato',
        header: 'Fecha Última Solicitud Corrección',
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const fechaAux = row.original?.observaciones_contrato?.contenido?.[row.original?.observaciones_contrato?.contenido?.length-1]?.fecha
          if(fechaAux){
            return dayjs(fechaAux).format("LLL")
          }
          return "N/A"
        } 
      },
      
      // ...clientDetails,
      // ...serviceDetails01,
      // ...activacionDetails,
      // ...ventaDetails,
      // ...geolocationDetails,
    ],
    []
  );

  return { 
    clientesCorporativosColumns,
    clientesCorporativosColumnsFilterMotivos
  };
};
